<template>
  <div class="">
    <navbar></navbar>

    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <router-link to="top">{{$t('ordertop.myhome')}} </router-link>/ {{$t('top.myorder')}}
          <div class="card mt-4">
            <div class="card-body">
              <h5 class="card-title">{{$t('orderList.titleList')}}</h5>
              <h6 class="card-subtitle mt-2 mb-2 text-muted"></h6>
              <p class="card-text">{{$t('orderList.textList')}}</p>
              <router-link to="order-list" class="btn btn-facebook">{{$t('orderList.listbutton')}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
  </div>
</template>

<style />

<script type="text/javascript">
import navbar from './navbar'
import copyright from '../user/copyright'
export default {
  components: { navbar, copyright },
  data: function () {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }

}
</script>
<style scoped>
.container{
  min-height:calc(100vh - 256px)
}
</style>



// WEBPACK FOOTER //
// src/components/operator/order.vue